// Helper functions for Pill component

// Maximum number of text lines before switching to scrollable mode
export const MAX_LINES_BEFORE_SCROLL = 5

// Check if content requires scrollable rendering based on line count
export const shouldUseScrollableContent = (textLines, secondaryLines) => {
  const totalLines = textLines.length + secondaryLines.length
  return totalLines > MAX_LINES_BEFORE_SCROLL
}

// Helper function to adjust color brightness for hover effect
export const adjustColorBrightness = (color, percent) => {
  const hex = color.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  const newR = Math.min(255, Math.max(0, r + Math.round((r * percent) / 100)))
  const newG = Math.min(255, Math.max(0, g + Math.round((g * percent) / 100)))
  const newB = Math.min(255, Math.max(0, b + Math.round((b * percent) / 100)))

  return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`
}
